/* eslint-disable import/prefer-default-export */
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
